// extracted by mini-css-extract-plugin
export default {"container":"checkboxinfo_container__GTinB"};